import { lazy, Suspense } from 'react'
import { createBrowserRouter, ScrollRestoration } from 'react-router-dom'

import './App.css'

// ROUTES
const LoggedInRoutes = lazy(() => import('./Components/Routes/LoggedInRoutes'))
const LoggedOutRoutes = lazy(() => import('./Components/Routes/LoggedOutRoutes'))
const AuthWrapper = lazy(() => import('./Components/Auth/AuthWrapper'))

const Router = createBrowserRouter([
	{
		path: '/*',
		element: <Suspense fallback=''><AuthWrapper /></Suspense>,
		errorElement: <Suspense fallback=''><div>This is the error route...</div></Suspense>,
		children: [
			{
				path: 'admin/*',
				element: (
					<>
						<ScrollRestoration />
						<Suspense fallback=''>
							<LoggedInRoutes />
						</Suspense>
					</>
				),
			},
			{
				path: '*',
				element: (
					<>
						<ScrollRestoration />
						<Suspense fallback=''>
							<LoggedOutRoutes />
						</Suspense>
					</>
				),
			},
		],
	}
])

export default Router